import { MockCard, MockKpiCard, MockButton, MockWarning } from '../../components/mockups/MockUI'
import { MockTable } from '../../components/mockups/MockTable'
import { MockBadge } from '../../components/mockups/MockBadge'

export function AnalyticsOverview() {
  return (
    <div className="space-y-6">
      <div>
        <h2 className="text-lg font-semibold text-gray-900 dark:text-gray-100 mb-2">
          Раздел «Аналитика»
        </h2>
        <p className="text-sm text-gray-600 dark:text-gray-400">
          Раздел для руководителей: сводные показатели по продажам и закупке за выбранный период.
          Состоит из вкладок — какие из них видны, зависит от роли. Рядовым менеджерам и закупщикам
          раздел недоступен.
        </p>
      </div>
      <MockTable
        caption="Вкладки и доступ"
        columns={[{ header: 'Вкладка' }, { header: 'Кому видна' }, { header: 'Что внутри' }]}
        rows={[
          [
            <MockBadge color="blue">Сводка</MockBadge>,
            'ADMIN, Гендиректор, РОП',
            'KPI с дельтами, воронка, топы, сравнение периодов',
          ],
          [
            <MockBadge color="teal">КП</MockBadge>,
            'ADMIN, Гендиректор, РОП',
            'КП-таймлайн заявок по менеджерам + история заявки',
          ],
          [
            <MockBadge color="purple">Обзор</MockBadge>,
            'ADMIN, Гендиректор, РОП',
            'Сквозная воронка, узкие места, срыв дедлайнов, «Где сейчас застряло», динамика по дням',
          ],
          [
            <MockBadge color="orange">Клиенты</MockBadge>,
            'ADMIN, Гендиректор, РОП',
            'Конверсия по сегменту и категории, таблица клиентов, «спящие»',
          ],
          [
            <MockBadge color="orange">Менеджеры</MockBadge>,
            'ADMIN, Гендиректор, РОП',
            'План/факт, АКБ, клиентская база, просрочки, нагрузка',
          ],
          [
            <MockBadge color="green">Закупщики</MockBadge>,
            'ADMIN, Гендиректор, РОЗ',
            'Квоты, запросы поставщикам, win-rate, база поставщиков',
          ],
          [
            <MockBadge color="green">Поставщики</MockBadge>,
            'ADMIN, Гендиректор, РОЗ',
            'Реестр-воронка: запрошено → ответил → в заказ',
          ],
        ]}
      />
      <MockCard>
        <div className="text-sm text-gray-600 dark:text-gray-400 space-y-2">
          <div className="font-medium text-gray-800 dark:text-gray-200">Период и «светофор»:</div>
          <ul className="list-disc list-inside space-y-1">
            <li>
              Селектор периода в шапке — Месяц / Квартал / Год / Период… — один на все вкладки
            </li>
            <li>
              Над вкладками — сводный «светофор»: зелёная строка «Критичных проблем не обнаружено»
              либо блок «Сводка — требует внимания» со списком алёртов (красная точка — критично,
              жёлтая — предупреждение)
            </li>
          </ul>
        </div>
      </MockCard>
      <MockCard>
        <div className="text-sm text-gray-600 dark:text-gray-400 space-y-2">
          <div className="font-medium text-gray-800 dark:text-gray-200">Состояние не теряется:</div>
          <p>
            Активная вкладка, выбранный период, сортировки и фильтры таблиц запоминаются. Можно
            провалиться в заявку или в её историю, вернуться назад — раздел откроется на той же
            вкладке с теми же фильтрами. Состояние сбрасывается только при полной перезагрузке
            страницы (F5).
          </p>
        </div>
      </MockCard>
    </div>
  )
}

export function AnalyticsSummaryTab() {
  return (
    <div className="space-y-6">
      <div>
        <h2 className="text-lg font-semibold text-gray-900 dark:text-gray-100 mb-2">
          Вкладка «Сводка»
        </h2>
        <p className="text-sm text-gray-600 dark:text-gray-400">
          Главный экран руководителя. Все цифры считаются по когорте создания: берутся заявки,
          созданные в выбранном периоде, и по ним — КП, заказы, исходы. Поэтому суммы совпадают с
          разделом «Заявки» при том же фильтре по дате создания.
        </p>
      </div>
      <div className="grid grid-cols-2 lg:grid-cols-3 gap-3">
        <MockKpiCard value="84" label="Заявок создано" color="brand" />
        <MockKpiCard value="12" label="Новых клиентов" color="blue" />
        <MockKpiCard value="640" label="Позиций" color="brand" />
        <MockKpiCard value="12,4 млн ₽" label="Сумма КП выставлено" color="orange" />
        <MockKpiCard value="3,1 млн ₽" label="Сумма в заказ" color="green" />
        <MockKpiCard value="27%" label="Конверсия КП→заказ" color="green" />
      </div>
      <MockCard>
        <div className="text-sm text-gray-600 dark:text-gray-400 space-y-2">
          <div className="font-medium text-gray-800 dark:text-gray-200">KPI-карточки:</div>
          <ul className="list-disc list-inside space-y-1">
            <li>Под каждым значением — дельта к предыдущему периоду той же длины</li>
            <li>
              Карточки кликабельны: «Заявок создано», «Позиций» и суммы открывают список заявок
              когорты; «Конверсия КП→заказ» — заявки, ушедшие в заказ
            </li>
            <li>
              «Новых клиентов» открывает модалку «Клиенты периода» — два списка: «Новые» (первая
              заявка клиента в этом периоде) и «Вернувшиеся»
            </li>
          </ul>
        </div>
      </MockCard>
      <MockCard>
        <div className="text-sm text-gray-600 dark:text-gray-400 space-y-2">
          <div className="font-medium text-gray-800 dark:text-gray-200">Воронка и исходы:</div>
          <ul className="list-disc list-inside space-y-1">
            <li>
              «Воронка заявок за период» — путь заявок когорты: создано → в заказ, % — от числа
              созданных
            </li>
            <li>
              «Исходы заявок периода» — кольцевая диаграмма текущего состояния: В заказ / КП
              выставлено / В работе / Отказ / В архиве
            </li>
          </ul>
          <div className="font-medium text-gray-800 dark:text-gray-200 mt-3">Топы и таблицы:</div>
          <ul className="list-disc list-inside space-y-1">
            <li>«Топ-10 сегментов клиентов в заказ» — направления бизнеса клиентов (₽)</li>
            <li>«Топ-10 сегментов товаров в заказ» — категории компонентов («Наименование»)</li>
            <li>«Топ-10 сегментов товаров по спросу» и «Топ-10 брендов» — по числу позиций</li>
            <li>«Матрицы поставки» — сумма в заказ по каналам</li>
            <li>
              «Клиенты периода» — топ-20 по числу заявок, бейдж «нов.» у новых; колонки «Сумма КП»,
              «В заказ», «Конв. по заявкам, %», «В заказ / КП, %»
            </li>
            <li>«Срез по менеджерам» — те же метрики по каждому менеджеру</li>
          </ul>
        </div>
      </MockCard>
      <MockCard>
        <div className="text-sm text-gray-600 dark:text-gray-400 space-y-3">
          <div className="font-medium text-gray-800 dark:text-gray-200">Фильтры сводки:</div>
          <p>
            Над сводкой — мультивыбор «Менеджеры», «Сегменты», «Города», «Бренды» (с поиском) и
            селект «Тип: все» (Текучка / Проект). Кнопка «Сбросить» очищает всё разом. Фильтры
            действуют на все блоки вкладки, включая режим сравнения.
          </p>
          <div className="font-medium text-gray-800 dark:text-gray-200">
            Сравнение периодов (A/B):
          </div>
          <ol className="list-decimal list-inside space-y-1">
            <li>
              Переключите тумблер <MockButton variant="secondary">Период</MockButton> /{' '}
              <MockButton variant="secondary">Сравнить</MockButton>
            </li>
            <li>
              Появится второй селектор периода («с …») — по умолчанию предыдущий месяц; период A —
              из шапки раздела
            </li>
            <li>
              Откроется таблица показателей с колонкой Δ (рост/падение в %, конверсия — в п.п.) и
              парные столбики «Деньги» и «Сегменты в заказ»
            </li>
            <li>Внизу — детализация топов по периоду A</li>
          </ol>
        </div>
      </MockCard>
    </div>
  )
}

export function AnalyticsPeopleTabs() {
  return (
    <div className="space-y-6">
      <div>
        <h2 className="text-lg font-semibold text-gray-900 dark:text-gray-100 mb-2">
          Вкладки «Менеджеры», «Клиенты», «Закупщики», «Поставщики»
        </h2>
        <p className="text-sm text-gray-600 dark:text-gray-400">
          Четыре сводные таблицы по людям и контрагентам. Во всех — клик по заголовку сортирует
          колонку, значок воронки открывает фильтр по значениям.
        </p>
      </div>
      <MockCard>
        <div className="text-sm text-gray-600 dark:text-gray-400 space-y-2">
          <div className="font-medium text-gray-800 dark:text-gray-200">
            «Менеджеры» — сводка за период:
          </div>
          <p>
            Колонки: «Менеджер», «План ₽», «Факт ₽», «%», «АКБ план/факт», «Клиентов», «Активных»,
            «Просрочки», «Нагрузка». Процент выполнения подсвечен: от 100% — зелёный, 70–99% —
            жёлтый, ниже — красный. План и факт — те же, что в разделе «Планирование».
          </p>
          <div className="font-medium text-gray-800 dark:text-gray-200 mt-3">«Клиенты»:</div>
          <ul className="list-disc list-inside space-y-1">
            <li>
              Блоки «Конверсия в заказ по сегменту» и «Конверсия в заказ по категории» — бары с
              долей заявок, ушедших в заказ
            </li>
            <li>
              Таблица «Клиенты — объём заявок vs конверсия»: колонки «Клиент», «Сегмент», «Кат.»,
              «Заявок», «В заказ», «Конверсия». Красная конверсия при большом объёме — сигнал «много
              заявок, мало заказов»
            </li>
            <li>Счётчик «спящих» клиентов за период — без заявок в периоде</li>
            <li>Клик по имени клиента открывает его карточку</li>
          </ul>
        </div>
      </MockCard>
      <MockCard>
        <div className="text-sm text-gray-600 dark:text-gray-400 space-y-2">
          <div className="font-medium text-gray-800 dark:text-gray-200">
            «Закупщики» — сводка за период:
          </div>
          <p>
            Колонки: «Закупщик», «Квот создано», «Запросов поставщикам», «Квот в заказ», «Win-rate»,
            «Поставщиков» (широта базы — сколько разных поставщиков закупщик использовал).
          </p>
          <div className="font-medium text-gray-800 dark:text-gray-200 mt-3">
            «Поставщики» — реестр-воронка:
          </div>
          <p>
            Колонки: «Поставщик», «Запрошено», «Ответил», «Response rate», «В заказ», «Win rate».
            Запрошено — позиции с квотой поставщика, ответил — квоты с ценой. Response rate — доля
            ответов, win rate — доля выигранных от отвеченных.
          </p>
        </div>
      </MockCard>
      <MockWarning>
        «Квот в заказ» и win-rate считаются по привязке выигравшей квоты к позиции — она заполняется
        при оформлении новых заказов. По историческим данным показатель может быть пустым или
        заниженным.
      </MockWarning>
    </div>
  )
}

export function AnalyticsKpTimeline() {
  return (
    <div className="space-y-6">
      <div>
        <h2 className="text-lg font-semibold text-gray-900 dark:text-gray-100 mb-2">
          КП-таймлайн и история заявки
        </h2>
        <p className="text-sm text-gray-600 dark:text-gray-400">
          Вкладка «КП» — быстрый ответ на вопрос «какие заявки на какой стадии у каждого менеджера».
          Одна строка = одна заявка периода с вехами: создана → закупка просчитала все позиции → КП
          выставлено → КП отправлено заказчику.
        </p>
      </div>
      <MockTable
        caption="Столбцы таймлайна"
        columns={[{ header: 'Столбец' }, { header: 'Что означает' }]}
        rows={[
          ['Заявка', 'Номер заявки; клик открывает экран «История заявки»'],
          ['Менеджер / Клиент', 'Владелец заявки и её клиент'],
          ['Создана', 'Дата создания заявки'],
          [
            'Проквотирована',
            'Закупка просчитала все позиции: у каждой позиции есть реальная цена больше нуля',
          ],
          ['КП выставлено', 'Дата первого КП; пометка «×2» — если КП формировалось несколько раз'],
          ['Отправлено', 'Дата отправки КП заказчику'],
          [
            'Контроль КП',
            '«→ дата» — следующее действие (красным, если просрочено) или «✓ дата» — последнее выполненное касание',
          ],
          ['Статус', 'Текущий статус заявки'],
          [
            'Время',
            'Дней от создания до финала; у незакрытых — до «сейчас» (с «…»), от 14 дней — жёлтым, от 30 — красным',
          ],
        ]}
      />
      <MockCard>
        <div className="text-sm text-gray-600 dark:text-gray-400 space-y-2">
          <div className="font-medium text-gray-800 dark:text-gray-200">
            Фильтр-воронка на всех столбцах:
          </div>
          <ul className="list-disc list-inside space-y-1">
            <li>
              У столбцов-дат значение фильтра — сама дата либо «—» для пустой. Пример: «КП не
              отправлено» = в столбце «Отправлено» выбрать «—»
            </li>
            <li>«Контроль КП» фильтруется по категориям «Открытое» / «Выполнено» / «—»</li>
            <li>Сортировка кликом по заголовку работает на всех столбцах</li>
            <li>
              Справа сверху — счётчик «Заявок за период»; если список обрезан, появится подсказка
              «Показаны первые … — сузьте период для полного списка»
            </li>
          </ul>
        </div>
      </MockCard>
      <MockCard>
        <div className="text-sm text-gray-600 dark:text-gray-400 space-y-2">
          <div className="font-medium text-gray-800 dark:text-gray-200">
            Экран «История заявки» (drill-in):
          </div>
          <p>
            Клик по номеру заявки в таймлайне открывает не стандартную карточку, а отдельный
            read-only экран истории. Доступен ADMIN, Гендиректору и РОП.
          </p>
          <ul className="list-disc list-inside space-y-1">
            <li>Шапка-сводка: Клиент, Менеджер, Статус, Создана, КП отправлено, Дедлайн</li>
            <li>Блок «Контроль КП» — таймлайн касаний по КП, без возможности редактирования</li>
            <li>Блок «История изменений» — переходы статусов и действия пользователей (аудит)</li>
            <li>
              Ссылка «Открыть карточку заявки» ведёт в обычную карточку; «← Аналитика» возвращает в
              раздел — на ту же вкладку с сохранёнными фильтрами
            </li>
          </ul>
        </div>
      </MockCard>
    </div>
  )
}
